import { endpointUrl } from '../config'
import { withCustomUrl } from './customFetcher'

export const useFetchData = withCustomUrl(endpointUrl)
